<template lang="pug">
  .component.component-backoffice-note(v-if="item")
    .card( v-if="$is('listing')")
      .inner-content
        cardN(:showBullets="true", :showAction="true", :columns="5")
          div(slot="actionBullets")
            dropdown(:icon="'fa fa-ellipsis-v fa-2x action'", :position="'top'")
              VehicleNoteButtons(:item="item")
          .field-value(slot="n1") N{{item.id}}
          .field-value(slot="n2") {{item.description}}
          .field-value(slot="n3") {{annotable}}
          .field-value(slot="n4", v-if="item.valid_from") From
          .field-value(slot="n4", v-if="item.valid_from") {{$dateFormat(item.valid_from, $toMomentFormat(configuration.locale.locale_date_format.value))}}
          .field-value(slot="n5", v-if="item.valid_to") To
          .field-value(slot="n5", v-if="item.valid_to") {{$dateFormat(item.valid_to, $toMomentFormat(configuration.locale.locale_date_format.value))}}
          .field-url-detail(slot="actionPage", v-if="item.annotable_type")
            router-link(:to="noteUrl")
              i.fa.fa-angle-right.fa-3x.action
    .card( v-if="$is('entityList')")
      .inner-content
        cardN(:showBullets="true", :showAction="true", :columns="3")
          div(slot="actionBullets")
            dropdown(:icon="'fa fa-ellipsis-v fa-2x action'", :position="'top'")
              VehicleNoteButtons(:item="item")
          .field-value(slot="n1") N{{item.id}}
          .field-value(slot="n2") {{item.description}}
          .field-value(slot="n3") {{item.valid_from}}
          .field-value(slot="n3") {{item.valid_to}}

    .card(v-if="$is('table')" )
      .inner-content
        .row
          .column
            label Description
            .field-value  {{item.description}}
          .column.shrink
            label Created
            .field-value {{item.created_at}}
          .column.shrink
            VehicleNoteButtons(:item="item", @itemUpdated="$emit('itemUpdated')")
</template>
<script type="text/babel">
import CardN from 'components/structure/CardN'
import Dropdown from '../structure/foundation/Dropdown'
import VehicleCostButtons from '../structure/ui/actions/VehicleCostButtons'
import VehicleNoteButtons from '../structure/ui/actions/VehicleNoteButtons'
import {mapState} from 'vuex'

export default {
  name: "Note",
  components: {
    VehicleNoteButtons,
    VehicleCostButtons,
    Dropdown,
    CardN,
  },
  data() {
    return {}
  },
  created() {
  },
  methods: {},
  computed: {
    noteUrl() {
      switch (this.item.annotable_type) {
        case'App\\Models\\Vehicle':
          return {name: 'vehicle-notes', params: {id: this.item.annotable_id}}
        case'App\\Models\\Reservation':
          return {name: 'reservation', params: {id: this.item.annotable_id}}
        case'App\\Models\\Driver':
          return {name: 'driver', params: {id: this.item.annotable_id}}
      }
    },
    annotable() {
      return this.item.annotable_type ? `${this.item.annotable_type.split('\\').pop()} ${this.item.annotable_id} ` : 'Global note'
    },
    ...mapState({
      configuration: state => state.configuration,
    })
  },
  props: {
    item: Object,
    type: {
      type: String,
      default: ''
    }
  },
}
</script>
<style lang="sass" rel="stylesheet/sass">
.component.component-backoffice-note
  .description
    white-space: pre
</style>



// WEBPACK FOOTER //
// Note.vue?63abb668